import { Row, Col, Icon, Button } from 'antd';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

export default class Pending extends React.Component {
    constructor(props) { super(props); }

    clickLink() {
        const path = ssCommonUtils.setEnvPrefix('/home');
        window.location.href=(path);
    }


    render() {
        return (
            <div className='afsp-login-indicator-status-error'>
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                    <Icon type='exclamation-circle-o' style={{ fontSize: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                        {'Login and Registration is Currently Disabled.'}
                    </span>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            <div style={{ fontStyle: 'italic', lineHeight: '14px' }}>
                                {'During the transition process to the new Final Rule Version of the FTSP portal, there will be a no-system-access period for all users.'}<br></br><br></br>
                                {'Your account may be ACTIVE, however login is DISABLED during this no-system-access period.'}
                            </div>
                        </Col>
                    </Row>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            
                            <Button onClick={() => this.clickLink()}>
                                {'Back To Home'}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}